import React from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import windows from 'assets/windowsIcons/windows.png';
import pullup from 'assets/windowsIcons/pullup.png';
import folder from 'assets/windowsIcons/318(16x16).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import go from 'assets/windowsIcons/290.png';

const jobs = [
  {
    company: 'Impact Analytics.ai',
    role: 'AI Product Manager',
    period: 'Sep 2023 – Present',
    tag: 'Current Employer (They Know What I\'m Up To)',
    emoji: '🤖',
    bullets: [
      'Built an agentic AI platform for 1,500+ retail stores. Turns out, SKU-level AI agents are better at inventory decisions than humans 3 coffees deep and staring at a pivot table.',
      'Launched an enterprise Agent Studio — multi-agent workflows, RAG retrieval, contextual reasoning, chat-driven analytics. A control room where AI agents argue productively so your team doesn\'t have to.',
      'Built LLM evaluation frameworks so models don\'t confidently tell retailers to stock 10,000 umbrellas in a desert. (Hallucination detection: my full-time paranoia, embedded into production.)',
      'Balanced performance, latency, quality, and token cost. Made great AI that doesn\'t cost more than the company\'s revenue.',
      'Championed Responsible AI — bias monitoring, explainability, compliance guardrails. Shipping fast is great; shipping fast and irresponsibly is a LinkedIn post waiting to happen.',
    ],
  },
  {
    company: 'Accenture Strategy & Consulting',
    role: 'Management Consulting Analyst',
    period: 'May 2023 – Aug 2025',
    tag: 'Fortune 500 Whisperer',
    emoji: '🏢',
    bullets: [
      'Designed a GenAI legal case management system for Meta — AI that reads contracts, not just generates them. Reduced manual legal review effort by 30–40%. Lawyers still employed.',
      'Advised LVMH & Dior on Responsible AI governance. Yes, I made luxury brands worry about AI bias. Explaining explainability to a Dior exec was not lost on anyone.',
      'Built GenAI accelerators for Google. Helped Google move faster. (I know. I know. It\'s fine.)',
      'Redesigned Amazon\'s retail planning platform — errors dropped from 15% to <1%. Amazon did not build a statue. I check occasionally.',
      'Led CXO-level AI strategy workshops. Translated LLMs for C-suite using sandwich analogies.',
      'Designed prompt libraries and eval frameworks for Accenture\'s internal GenAI product (Wizard). Because even the wizard\'s outputs need QA.',
    ],
  },
  {
    company: 'Infosys',
    role: 'Technology Analyst',
    period: 'May 2018 – Jul 2021',
    tag: 'Origin Story (Pre-AI Hype Era)',
    emoji: '⚡',
    bullets: [
      'Boosted digital banking platform adoption by 20%. Back when "AI feature" meant a really good autocomplete.',
      'Reduced support queries by 25%. Users called less because the product worked better. Revolutionary concept.',
      'Shipped features aligned to OKRs, survived sprint planning. Character-building stuff.',
    ],
  },
  {
    company: 'Optum (United Health Group)',
    role: 'Product Management Intern',
    period: 'Apr 2022 – Jun 2022',
    tag: 'Bonus Level',
    emoji: '🏥',
    bullets: [
      'Healthcare product strategy using AI/ML, NLP, and blockchain — yes, all three. It was 2022. We were optimistic.',
      'Launched MVP for HCP ecosystem, data profiling, analysis, and KPI tracking. Healthcare + tech = never a dull standup.',
    ],
  },
];

function Experience({ onClose }) {
  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
  }
  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img src={folder} alt="" className="com__address_bar__content__img" />
          <div className="com__address_bar__content__text">C:\Users\Mahip\experience.log</div>
          <img src={dropdown} alt="" className="com__address_bar__content__img" />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>
      <div className="com__content">
        <div className="com__content__inner">
          {/* LEFT SIDEBAR */}
          <div className="com__content__left">
            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">Career Files</div>
                <img src={pullup} alt="" className="com__content__left__card__header__img" />
              </div>
              <div className="com__content__left__card__content">
                {jobs.map(j => (
                  <div key={j.company} className="com__content__left__card__row">
                    <span style={{ marginRight: 4 }}>{j.emoji}</span>
                    <div className="com__content__left__card__text">{j.company}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">PM Wisdom</div>
                <img src={pullup} alt="" className="com__content__left__card__header__img" />
              </div>
              <div className="com__content__left__card__content">
                <div className="meme-tip">"A PM tries to walk into a bar, but the door isn't shipping until next release."</div>
              </div>
            </div>
          </div>

          {/* RIGHT MAIN PANEL */}
          <div className="com__content__right">
            {jobs.map(job => (
              <div key={job.company} className="exp-card">
                <div className="exp-card__header">
                  <span className="exp-card__emoji">{job.emoji}</span>
                  <div>
                    <div className="exp-card__role">{job.role} — {job.company}</div>
                    <div className="exp-card__meta">{job.period} · <em>{job.tag}</em></div>
                  </div>
                </div>
                <ul className="exp-card__list">
                  {job.bullets.map((b, i) => <li key={i}>{b}</li>)}
                </ul>
              </div>
            ))}
            <div className="bottom-meme">
              "My backlog is like my fridge: full of things I keep promising I'll deal with."
            </div>
          </div>
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative; display: flex; align-items: center;
    height: 24px; border-bottom: 1px solid rgba(255,255,255,0.7); flex-shrink: 0;
  }
  .com__options {
    height: 23px; border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1); padding: 1px 0 1px 2px; flex: 1;
  }
  .com__windows-logo { height: 100%; border-left: 1px solid white; border-bottom: 1px solid rgba(0,0,0,0.1); }
  .com__address_bar {
    flex-shrink: 0; border-top: 1px solid rgba(255,255,255,0.7); height: 20px;
    font-size: 11px; display: flex; align-items: center; padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title { color: rgba(0,0,0,0.5); padding: 5px; }
  .com__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid; height: 100%; display: flex; flex: 1;
    align-items: center; background-color: white; position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { white-space: nowrap; position: absolute; left: 16px; right: 17px; }
  }
  .com__address_bar__go {
    display: flex; align-items: center; padding: 0 18px 0 5px; height: 100%; position: relative;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .com__content {
    flex: 1; border: 1px solid rgba(0,0,0,0.4); border-top-width: 0;
    background-color: #f1f1f1; overflow: auto; font-size: 11px; position: relative;
  }
  .com__content__inner { display: flex; height: 100%; overflow: auto; }
  .com__content__left {
    width: 175px; min-width: 175px;
    background: linear-gradient(to bottom, #748aff 0%, #4057d3 100%);
    overflow: auto; padding: 10px;
  }
  .com__content__left__card {
    border-top-left-radius: 3px; border-top-right-radius: 3px;
    width: 100%; overflow: hidden; margin-bottom: 12px;
  }
  .com__content__left__card__header {
    display: flex; align-items: center; height: 23px;
    padding-left: 11px; padding-right: 2px;
    background: linear-gradient(to right, rgb(240,240,255) 0, rgb(240,240,255) 30%, rgb(168,188,255) 100%);
    &__text { font-weight: 700; color: #0c327d; flex: 1; font-size: 11px; }
    &__img { width: 18px; height: 18px; }
  }
  .com__content__left__card__content {
    padding: 5px 10px;
    background: linear-gradient(to right, rgb(180,200,251) 0%, rgb(164,185,251) 50%, rgb(180,200,251) 100%);
  }
  .com__content__left__card__row { display: flex; margin-bottom: 5px; align-items: center; }
  .com__content__left__card__text { font-size: 10px; line-height: 1.3; color: #0c327d; }
  .meme-tip {
    font-size: 10px; color: #0c327d; font-style: italic; line-height: 1.4; padding: 2px 0;
  }
  .com__content__right { flex: 1; overflow: auto; background-color: #fff; padding: 12px 16px; }
  .exp-card {
    border: 1px solid #d0dff8; background: linear-gradient(180deg, #fafcff 0%, #f0f6ff 100%);
    margin-bottom: 12px; padding: 12px 14px;
  }
  .exp-card__header { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 8px; }
  .exp-card__emoji { font-size: 20px; line-height: 1; flex-shrink: 0; margin-top: 1px; }
  .exp-card__role { font-weight: bold; color: #0a3d90; font-size: 12px; }
  .exp-card__meta { font-size: 10px; color: #666; margin-top: 2px; }
  .exp-card__list {
    margin: 0; padding-left: 16px; font-size: 11px; line-height: 1.55; color: #222;
    li + li { margin-top: 5px; }
  }
  .bottom-meme {
    text-align: center; font-style: italic; color: #888; font-size: 11px;
    padding: 10px; border-top: 1px solid #e8eeff; margin-top: 4px;
  }
`;

export default Experience;
